module.exports = __webpack_public_path__ + "img/anthony_pixie.167daa51.png";